module.exports = __WEBPACK_EXTERNAL_MODULE_248__;


//////////////////
// WEBPACK FOOTER
// external {"root":"numbro","commonjs2":"numbro","commonjs":"numbro","amd":"numbro"}
// module id = 248
// module chunks = 0